module.exports = __webpack_public_path__ + "img/ctrl-hadamard-stub-down--.59960241.svg";